export const reading = {
    uk: {
        heading: "Читання",
        squares: [
            { title: "Тексти", path: "/reading/texts" },
            { title: "Знаки", path: "/reading/signs" }
        ],
        readingTextsHeader: "Тексти для читання",
        readingSignsHeader: "Знаки і написи",
        listOfLessons: "Список уроків"
    },
    en: {
        heading: "Reading",
        squares: [
            { title: "Texts", path: "/reading/texts" },
            { title: "Signs", path: "/reading/signs" }
        ],
        readingTextsHeader: "Reading Texts",
        readingSignsHeader: "Reading Signs",
        listOfLessons: "List of Lessons"
    }
}